import React, { MouseEventHandler, ReactNode } from 'react';

import { Card as StyledCard } from './styles';

interface ICard {
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLDivElement>;
  [attr: string]: any;
}

const Card = ({ children, onClick, ...props }: ICard) => (
  <span onClick={onClick}>
    <StyledCard {...props}>{children}</StyledCard>
  </span>
);

export default Card;
